import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/176/components/features/cases/OldComponents/cases/ukassa/index.jsx");
